document.addEventListener('DOMContentLoaded', function () {
    const sliderContainer = document.querySelector('.HeroSlider');


        const slides = document.querySelectorAll('.HeroSlider__bg');
        const nextButton = document.querySelector('.next__slide');
        const prevButton = document.querySelector('.prev__slide');
        const paginationDots = document.querySelectorAll('.dot');


    let currentIndex = 0;
    let intervalId; // Zmienna przechowująca ID interwału

    if (sliderContainer) {
        const changeSlide = (index) => {
            slides[currentIndex].classList.remove('active');
            paginationDots[currentIndex].classList.remove('active');
            currentIndex = index;
            slides[currentIndex].classList.add('active');
            paginationDots[currentIndex].classList.add('active');
        };

        nextButton.addEventListener('click', () => {
            clearInterval(intervalId);
            changeSlide((currentIndex + 1) % slides.length);
            intervalId = setInterval(() => {
                changeSlide((currentIndex + 1) % slides.length);
            }, 5000);
        });

        prevButton.addEventListener('click', () => {
            clearInterval(intervalId);
            changeSlide((currentIndex - 1 + slides.length) % slides.length);
            intervalId = setInterval(() => {
                changeSlide((currentIndex + 1) % slides.length);
            }, 5000);
        });

        paginationDots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                clearInterval(intervalId);
                changeSlide(index);
                intervalId = setInterval(() => {
                    changeSlide((currentIndex + 1) % slides.length);
                }, 5000);
            });
        });

        intervalId = setInterval(() => {
            changeSlide((currentIndex + 1) % slides.length);
        }, 5000);
    }
});
